import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import AddOrEditEquipmentPerStockLocationForm from '../add_or_edit_equipment_per_stocklocation_form/AddOrEditEquipmentPerStockLocationForm';

const { Content } = Layout;

const NewEquipmentPerStockLocationPage: FC<any> = ({ history, match }): React.ReactElement => {
	const stockLocationId = useMemo(() => match.params.id, [match.params.id]);

	return (
		<Content>
			<LogOnMountWithStandardEventProperties eventType="visited supplier new equipment per stock location page" />
			<Row style={{ margin: '0.5em -8px' }} gutter={16}>
				<Col span={24}>
					<Card>
						<div>
							<h5 style={{ marginBottom: 24 }}>New Equipment</h5>
							<AddOrEditEquipmentPerStockLocationForm
								formData={{}}
								stockLocationId={stockLocationId}
								onSuccess={(rec) =>
									history.push(`/supplier/equipments/equipmentPerStockLocation/detail/${rec.id}`)
								}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</Content>
	);
};

export default withRouter(connect()(NewEquipmentPerStockLocationPage));
